'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamStateContentModel = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class2, _temp2;

var _mobx = require('mobx');

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _taskEntity = require('task-entity');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var TeamStateContentModel = exports.TeamStateContentModel = (_dec = _mobx.observable.shallow, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(TeamStateContentModel, _BaseContentModel);

  function TeamStateContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TeamStateContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TeamStateContentModel.__proto__ || (0, _getPrototypeOf2.default)(TeamStateContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'displayName', _descriptor, _this), _initDefineProp(_this, 'runModel', _descriptor2, _this), _initDefineProp(_this, 'tasks', _descriptor3, _this), _initDefineProp(_this, 'isWaitState', _descriptor4, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /*@slot */
  /*@slot */
  /*@slot( TaskContentModel )*/
  // /*@slot( DictionaryContentModel )*/ @observable transitions =  null
  // /*@slot( DictionaryContentModel )*/ @observable customCommands = null
  /*@slot */

  return TeamStateContentModel;
}(_baseContentmodel2.default), _class2.maxParents = ["RoundContentModel", 1], _class2._slots = {
  displayName: "",
  tasks: [_taskEntity.ContentModel],
  runModel: "",
  // transitions: {},
  // customCommands: {},
  isWaitState: false }, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'displayName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'runModel', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'tasks', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'isWaitState', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class));
var _default = TeamStateContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TeamStateContentModel, 'TeamStateContentModel', 'src/entity_modules/teamstate-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/teamstate-entity/contentmodel.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/teamstate-entity/contentmodel.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/teamstate-entity/contentmodel.js
// module chunks = 0